import React from 'react'

type IconProps = {
    className?: string
}

export const RulerIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M9.33333 2.66669H13.3333V6.66669H9.33333V2.66669Z"
            stroke="#3E5060"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.66667 9.33335H6.66667V13.3334H2.66667V9.33335Z"
            stroke="#3E5060"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33333 11.3334C9.33333 11.8638 9.54405 12.3725 9.91912 12.7476C10.2942 13.1226 10.8029 13.3334 11.3333 13.3334C11.8638 13.3334 12.3725 13.1226 12.7475 12.7476C13.1226 12.3725 13.3333 11.8638 13.3333 11.3334C13.3333 10.8029 13.1226 10.2942 12.7475 9.91914C12.3725 9.54407 11.8638 9.33335 11.3333 9.33335C10.8029 9.33335 10.2942 9.54407 9.91912 9.91914C9.54405 10.2942 9.33333 10.8029 9.33333 11.3334Z"
            stroke="#3E5060"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.66667 4.66669C2.66667 4.92933 2.7184 5.1894 2.81891 5.43205C2.91942 5.67471 3.06674 5.89518 3.25245 6.0809C3.43817 6.26662 3.65865 6.41394 3.9013 6.51445C4.14395 6.61496 4.40402 6.66669 4.66667 6.66669C4.92931 6.66669 5.18938 6.61496 5.43203 6.51445C5.67469 6.41394 5.89516 6.26662 6.08088 6.0809C6.2666 5.89518 6.41392 5.67471 6.51443 5.43205C6.61494 5.1894 6.66667 4.92933 6.66667 4.66669C6.66667 4.40404 6.61494 4.14397 6.51443 3.90132C6.41392 3.65867 6.2666 3.43819 6.08088 3.25247C5.89516 3.06676 5.67469 2.91944 5.43203 2.81893C5.18938 2.71842 4.92931 2.66669 4.66667 2.66669C4.40402 2.66669 4.14395 2.71842 3.9013 2.81893C3.65865 2.91944 3.43817 3.06676 3.25245 3.25247C3.06674 3.43819 2.91942 3.65867 2.81891 3.90132C2.7184 4.14397 2.66667 4.40404 2.66667 4.66669Z"
            stroke="#3E5060"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
